export interface IRccapAdditionalQuestionWithValidation {
    id: number,
    question: string,
    answer: string,
    isValid: boolean,
    isDeleted: boolean
}